import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=04b3f90e&scoped=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3f90e",
  null
  
)

export default component.exports